import { jsx as _jsx } from "react/jsx-runtime";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { toastStack } from './toast.css.js';
export const ToastStack = () => {
    return (_jsx(ToastContainer, { style: toastStack, position: "top-right", autoClose: false, hideProgressBar: false, newestOnTop: true, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "light" }));
};
